export const tracking = {
  init() {
    // this is for direct tagging of elements in the site. See example in MyAccountCTA.jsx
    this.setupElementTaggingTracking()

    // for tracking umbraco forms with non-helpful urls. and thankyous
    this.setupUmbracoFormTracking()

    // custom event tracking that is easier to do in javascript rather than tagging links around the site
    this.setupCustomEventTracking()

    // check for umbraco form submission
    this.checkUmbracoFormTracking()

    // track the initial page load. This is used instead of the built-in GTM "Page View", so we can capture information from previous pages easier e.g. umbraco form submissions

    // Using a "fake page view" to fire page tracking for 2 reasons
    // - when trying to rerun the tags after cookie consent, you can't run the "Page View" event again
    // - makes it easier to run virtual page views and on-load page views without having separate rules
    dataLayer.push({
      event: 'Site Page View',
    })
  },
  isDev: location.hostname.match(/localhost|equator/),
  log(...args) {
    if (this.isDev) {
      console.log(args[0])
    }
  },
  setupElementTaggingTracking() {
    // this is for stuff that would require a rewrite to make click work. If you want to sort it out with react onclick handlers, be my guest
    document.addEventListener(
      'click',
      (e) => {
        if (e.target.matches('[data-event-category],[data-event-category] *')) {
          let element = e.target.closest('[data-event-category]')
          let cat = element.getAttribute('data-event-category')
          let act = element.getAttribute('data-event-action')
          let lab = element.getAttribute('data-event-label')
          this.trackEvent(cat, act, lab)
        }
      },
      false
    )
  },
  setPageview: function (pageView, pageViewOptions) {
    // this is just a shortcut for tracking the pageview with the supressevent option pretagged. This method is supposed to make it a bit clearer about what's going on and why?
    // There are a few occasion you want to set the pageview but not track the page yet (e.g. form submits) and then let the normal tracking in GTM pick it up.
    // The only real reason at the moment to do this when you want to set something before the trackingReady event (which is only delayed because of the login callback)

    this.trackPageview(
      pageView,
      pageViewOptions | this.pageViewOptions.SUPPRESS_EVENT
    )
  },

  trackPageview: function (pageView, pageViewOptions) {
    // if there are pageview options APPEND and/or PREPEND, then we will take the pageview and glue it to the current window.location.pathname

    if (pageView && pageViewOptions) {
      // append will trump prepend. Not doing both.
      if (pageViewOptions & this.pageViewOptions.APPEND) {
        pageView = window.location.pathname + '/' + pageView
      } else if (pageViewOptions & this.pageViewOptions.PREPEND) {
        pageView = '/' + pageView + '/' + window.location.pathname
      }

      if (pageViewOptions & this.pageViewOptions.KEEP_QUERYSTRING) {
        pageView += window.location.search
      }
    }

    if (pageView) {
      // get rid of any multiple slashes
      pageView = pageView.replace(/\/{2,}/g, '/')
    }

    let dlObject = {
      pageView: pageView,
    }

    if (!(pageViewOptions & this.pageViewOptions.SUPPRESS_EVENT)) {
      dlObject.event = 'Site Page View'
    }

    dataLayer.push(dlObject)

    this.log(dlObject)
  },

  pageViewOptions: {
    // uses bitwise for matching. Why? It feels a bit .nety
    APPEND: 1,
    SUPPRESS_EVENT: 2,
    KEEP_QUERYSTRING: 4,
    PREPEND: 8,
  },

  trackEvent(category, action, label) {
    let eventData = {
      event: 'trackEvent',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
    }

    dataLayer.push(eventData)

    this.log(eventData)
  },
  //==================================================================================================
  //	Singular Generic set dimension method
  //==================================================================================================
  setDataLayerKeyValue: function (key, value) {
    let data = {}
    data[key] = value
    dataLayer.push(data)
  },

  // site specific stuff.
  setupCustomEventTracking() {
    // social links at the bottom of the page
    document
      .querySelector('.footer__social-list')
      .addEventListener('click', (e) => {
        // get the event target
        if (e.target.matches('a,a *')) {
          let img = e.target.closest('a').querySelector('*') // strange traversal, but want to make sure that I am grabbing the image if I haven't clicked on the image
          console.info(e.target.tagName, img.tagName)
          let socialType = img.getAttribute('alt')
          this.trackEvent(
            'Page Event',
            'Social Link Footer',
            `Social Link - ${socialType}`
          )
        }
      })

    // track the menu opening/closing
    // store the header el for later use
    let header = document.querySelector('header.header.page-wrapper') // sorry if this is too specific, not sure where else headers have been used
    document.querySelector('.menu-btn__icon').addEventListener('click', (e) => {
      // check the header state.
      let isOpen = header.classList.contains('header--nav-open')

      this.trackEvent(
        'Page Event',
        'Main Menu',
        `Main Menu - ${isOpen ? 'closed' : 'opened'}`
      )
    })

    // track the main menu items
    header.querySelector('.main-nav__list').addEventListener('click', (e) => {
      if (e.target.matches('a,a *')) {
        // risk the chance that the event gets cancelled, rather than stop the nav and force the location.href
        let linkText = e.target.innerText

        this.trackEvent(
          'Page Event',
          'Main Menu',
          `Main Menu Nav - ${linkText}"}`
        )
      }
    })
  },

  //The umbraco stuff is pretty generic, but the rules and classes are based on the EQTR website
  setupUmbracoFormTracking() {
    /*
        contact form is fine.
            /contact/ => /thank-you-contact, maybe just use a generic /contact/thank-you-contact?
        
        Job form needs a tweak
            1 - /job-application-page/?jobtitle=project-manager , would be better to have /job-application-page/project-manager
            2 - goes to "thank-you-job", would be better to have /job-application-page/project-manager/thank-you-job or something

        Whitepaper form 
            /reports/whitepaper-energy-futures-report/ => /thank-you-contact, but might be something different.
            make it go to /reports/whitepaper-energy-futures-report/thank-you-contact
        */

    // so all umbraco forms need a little nudge to help with the tracking
    // there will need to be intervention on the razor end to intercept the dataLayer before the container gets initialised
    // thinking that maybe a little hack to the GTM container setup code to remove the "gtm.js" event might be needed?

    document.querySelector('.field-validation-error')

    let umbFormButton = document.querySelector(
      ".umbraco-forms-eqtr-form form button[type='submit']"
    )

    if (!umbFormButton) return

    // change the pageview if we are on the job page
    let jobtitle = location.search.match(/jobtitle=([^&]+)/)
    let pageview = location.pathname + ((jobtitle && jobtitle[1]) || '') + '/' // double slashes will get removed in the setpageview method

    // set the dataLayer
    this.setPageview(pageview)

    // tag the click on the submit button
    // can't hook into the submit event, think this is being fired with form.submit() which
    // doesn't fire submit listeners
    umbFormButton.addEventListener('click', function () {
      if (!document.querySelector('.form-row--invalid')) {
        // set a local variable to get picked up on the submission page. If you fire tracking here
        // there is a chance it will get stopped on the page submit
        // if this variable has been set then we can check to see if we are on the same page
        // if on the same page then we don't have a "thanks" page, so no tracking

        // if we are on
        sessionStorage['umbFormSubmitted'] = pageview
        // use this to set the "thanks" page view variable in GTM
      }
    })
  },
  checkUmbracoFormTracking() {
    let umbFormSubmitted = sessionStorage['umbFormSubmitted']
    sessionStorage.removeItem('umbFormSubmitted')

    if (umbFormSubmitted) {
      this.setPageview(umbFormSubmitted + location.pathname)
    }
  },
}

// self initialisier
tracking.init()
